import React from "react";
import { withRouter } from "react-router-dom";
import OwnerDetails from "../../widgets/office/owner/OwnerDetails";
import TotalOfficeStockBuiltOwner from "../../widgets/office/owner/TotalOfficeStockBuiltOwner";
import UnderConstructionOwner from "../../widgets/office/owner/UnderConstructionOwner";
import ProposedValuationOwner from "../../widgets/office/owner/ProposedValuationOwner";
import CurrentVacancyOwner from "../../widgets/office/owner/CurrentVacancyOwner";
import OccupiersWidgetOwner from "../../widgets/office/owner/OccupiersWidgetOwner";
import CurrentPassingRentOwner from "../../widgets/office/owner/CurrentPassingRentOwner";
import WaleOwner from "../../widgets/office/owner/WaleOwner";
import ReleasingSpreadOwner from "../../widgets/office/owner/ReleasingSpreadOwner";
import DemandSupplyVacancyGraphOwner from "../../widgets/office/owner/DemandSupplyVacancyGraphOwner";
import TopOccupiersTableOwner from "../../widgets/office/owner/TopOccupiersTableOwner";
import PassingRentMarketRentGraphOwner from "../../widgets/office/owner/PassingRentMarketRentGraphOwner";
import FutureRentEscalationsGraphOwner from "../../widgets/office/owner/FutureRentEscalationsGraphOwner";
import TopAssetsBrookfieldTableOwner from "../../widgets/office/owner/TopAssetsBrookfieldTableOwner";
import AreaLeasedTransactionSizeGraphOwner from "../../widgets/office/owner/AreaLeasedTransactionSizeGraphOwner";
import LeaseExpiryOccupiersGraphOwner from "../../widgets/office/owner/LeaseExpiryOccupiersGraphOwner";
import UpcommingSupplyGraphOwner from "../../widgets/office/owner/UpcommingSupplyGraphOwner";
import CitywisePresenceGraphOwner from "../../widgets/office/owner/CitywisePresenceGraphOwner";
import SectorBreakupAreaOccupiedGraphOwner from "../../widgets/office/owner/SectorBreakupAreaOccupiedGraphOwner";
import SectorWiseRentGraphOwner from "../../widgets/office/owner/SectorWiseRentGraphOwner";
import MajorRecentTransactionsTableOwner from "../../widgets/office/owner/MajorRecentTransactionsTableOwner";
import LatestNews from "../../widgets/office/LatestNewsAsset";
import KeyDocuments from "../../widgets/office/KeyDocuments";
class Owner1 extends React.Component {
  render() {
    console.log('jgjcykufito');
    return (
      <div className="container-fluid developer">
        <div className="row mb-4">
          <div className="col-lg-4">
            <OwnerDetails />
          </div>
          <div className="col-lg-8">
            <div className="row">
              <div class="col-lg-3 mb-4">
                <TotalOfficeStockBuiltOwner />
              </div>
              <div class="col-lg-3 mb-4">
                <UnderConstructionOwner />
              </div>
              <div class="col-lg-3 mb-4">
                <ProposedValuationOwner />
              </div>
              <div class="col-lg-3 mb-4">
                <CurrentVacancyOwner />
              </div>
              <div class="col-lg-3 mb-4">
                <OccupiersWidgetOwner />
              </div>
              <div class="col-lg-3 mb-4">
                <CurrentPassingRentOwner />
              </div>
              <div class="col-lg-3 mb-4">
                <WaleOwner />
              </div>
              <div class="col-lg-3 mb-4">
                <ReleasingSpreadOwner />
              </div>
            </div>
          </div>
        </div>
        <div className="row mb-4">
          <div className="col-lg-8">
            <DemandSupplyVacancyGraphOwner />
          </div>
          <div className="col-lg-4">
            <TopOccupiersTableOwner />
          </div>
        </div>
        <div className="row mb-4">
          <div className="col-lg-6">
            <PassingRentMarketRentGraphOwner />
          </div>
          <div className="col-lg-6">
            <FutureRentEscalationsGraphOwner />
          </div>
        </div>
        <div className="row mb-4">
          <div className="col-lg-12">
            <TopAssetsBrookfieldTableOwner />
          </div>
        </div>
        <div className="row mb-4">
          <div className="col-lg-6">
            <AreaLeasedTransactionSizeGraphOwner />
          </div>
          <div className="col-lg-6">
            <LeaseExpiryOccupiersGraphOwner />
          </div>
        </div>
        <div className="row mb-4">
          <div className="col-lg-6">
            <UpcommingSupplyGraphOwner />
          </div>
          <div className="col-lg-6">
            <CitywisePresenceGraphOwner />
          </div>
        </div>
        <div className="row mb-4">
          <div className="col-lg-6">
            <SectorBreakupAreaOccupiedGraphOwner />
          </div>
          <div className="col-lg-6">
            <SectorWiseRentGraphOwner />
          </div>
        </div>
        <div className="row mb-4">
          <div className="col-lg-12">
            <MajorRecentTransactionsTableOwner />
          </div>
        </div>
        <div className="row">
          <div className="col-lg-6">
            <LatestNews />
          </div>
          <div className="col-lg-6">
            <KeyDocuments />
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(Owner1);
